import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyDocumentMetadata } from "./utils/metadata";
applyDocumentMetadata();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-422" data-mp="269alcfi5l86w" />);
}